import React, { ReactElement } from 'react';

import moment, { Moment } from 'moment';

export interface WeeklyTimeSpanProps {
  date: Moment;
  onClick: () => void;
}

function WeeklyTimeSpan({ date, onClick }: WeeklyTimeSpanProps): ReactElement {
  const [startOfWeek, endOfWeek] = [
    moment.utc(date).startOf('week'),
    moment.utc(date).endOf('week'),
  ];

  if (startOfWeek.isSame(endOfWeek, 'month')) {
    return (
      <div className="c-calendar__date" data-testid="calendar-time-span-date" onClick={onClick}>
        <div className="c-calendar__year" data-testid="calendar-time-span-year">{startOfWeek.format('MMM')}</div>
        <div className="c-calendar__month" data-testid="calendar-time-span-month">{`${startOfWeek.date()}-${endOfWeek.date()}`}</div>
      </div>
    );
  }

  return (
    <div className="c-calendar__date" data-testid="calendar-time-span-date" onClick={onClick}>
      <div className="c-calendar__year" data-testid="calendar-time-span-year">{startOfWeek.format('MMM')}</div>
      <div className="c-calendar__month" data-testid="calendar-time-span-month">{`${startOfWeek.date()}-`}</div>

      <div className="c-calendar__year" data-testid="calendar-time-span-year">{endOfWeek.format('MMM')}</div>
      <div className="c-calendar__month" data-testid="calendar-time-span-month">{endOfWeek.date()}</div>
    </div>
  );
}

export default WeeklyTimeSpan;
